var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('effectScatter',{ref:"chart1",style:({width:_vm.width,height:_vm.height}),attrs:{"chart":"chart1"}})}
var staticRenderFns = []

export { render, staticRenderFns }